import posthog from "posthog-js";

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST || "https://eu.i.posthog.com";

const URL_PROPERTIES = ["$current_url", "$initial_current_url", "$session_entry_url", "$referrer", "$initial_referrer"];

const stripUrlParams = (value) => {
  if (typeof value !== "string") return value;

  const paramsStart = value.search(/[?#]/);
  return paramsStart === -1 ? value : value.slice(0, paramsStart);
};

const sanitizeProperties = (properties) => {
  if (!properties || typeof properties !== "object") return properties;

  const sanitized = { ...properties };

  URL_PROPERTIES.forEach((property) => {
    if (property in sanitized) {
      sanitized[property] = stripUrlParams(sanitized[property]);
    }
  });

  if (sanitized.$set) sanitized.$set = sanitizeProperties(sanitized.$set);
  if (sanitized.$set_once) sanitized.$set_once = sanitizeProperties(sanitized.$set_once);

  return sanitized;
};

const sanitizeEvent = (event) => {
  if (!event?.properties) return event;

  return { ...event, properties: sanitizeProperties(event.properties) };
};

// When the key is unset (local dev, tests) the wrapper no-ops and never touches the network.
const isEnabled = () => Boolean(POSTHOG_KEY);

let initialized = false;

const init = (shopDomain) => {
  if (!isEnabled() || !shopDomain || initialized) return;

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    persistence: "localStorage",
    persistence_name: shopDomain,
    capture_pageview: "history_change",
    person_profiles: "identified_only",
    disable_session_recording: true,
    before_send: sanitizeEvent,
  });

  initialized = true;
};

const identify = (domain) => {
  if (!isEnabled() || !domain) return;

  posthog.identify(domain);
};

const track = (event, props) => {
  if (!isEnabled()) return;

  posthog.capture(event, props);
};

export { init, identify, track, sanitizeEvent };
